module.exports = __webpack_public_path__ + "static/img/notFount.9a370aa2.png";